export default __webpack_public_path__ + "static/media/1841.839dac97.png";